import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { NumbersSection as Original } from 'components/organisms'
import { NumbersSectionSettings, NumbersSectionFloatingSettings } from './NumbersSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import {
  layoutDefaultProps,
  layoutItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'
import { numbersCardItemParams } from '../NumbersCard'

export const defaultProps = {
  ...layoutDefaultProps(undefined, false),
}

export const numbersSectionItemParams = (enabled, id, blockProps, children) => ({
  ...layoutItemParams(blockProps),
  pk: id,
  children: getItemChildren(enabled, children?.[0], numbersCardItemParams),
})

export const dynamicProps = []

export const NumbersSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-numbers-section ${props.className}`}>
        <Original
          item={numbersSectionItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

NumbersSection.craft = withCraft({
  name: 'NumbersSection',
  defaultProps: defaultProps,
  settings: NumbersSectionSettings,
  floatingSettings: NumbersSectionFloatingSettings,
})
